import React from 'react'
import { FiCalendar, FiTruck, FiCreditCard, FiFileText } from 'react-icons/fi'
import { Customer as customerDelivery } from './delivery/types'
import { Customer as customerPurchase } from './purchase/types'
import {
  Container,
  HeaderRow,
  Title,
  Logo,
  InfoGrid,
  CustomerBlock,
  OrderBlock,
  OrdersList,
} from './style/OrderHeader'

interface Props {
  isDelivery: boolean
  customer: customerDelivery | customerPurchase
  orderIds: number[]
  creationDatetime: Date
  payment: string
  planId: string
}

const OrderHeader = ({
  isDelivery,
  customer,
  orderIds,
  creationDatetime,
  planId,
  payment,
}: Props) => {
  return (
    <Container>
      <HeaderRow>
        <Title>{!isDelivery ? 'Pedido' : 'Fatura'}</Title>
        <Logo src="/img/new_clubbi.png" alt="Clubbi" />
      </HeaderRow>

      <InfoGrid>
        <CustomerBlock>
          <h4>{customer.razaoSocial}</h4>
          <p>{customer.cnpj}</p>
          <p>
            {customer.streetName}, {customer.streetNumber}
          </p>
          <p>
            {customer.neighborhood}, {customer.city} - {customer.state} - {customer.zipCode}
          </p>
        </CustomerBlock>

        <OrderBlock>
          <p>
            <FiFileText />
            <OrdersList>
              <strong>Pedido:</strong> {orderIds.join(', ')}
            </OrdersList>
          </p>
          <p>
            <FiCalendar /> <strong>Emissão:</strong> {creationDatetime.toLocaleDateString('pt-BR')}
          </p>
          <p>
            <FiTruck /> <strong>Plano de entrega:</strong> {planId}
          </p>
          <p>
            <FiCreditCard /> <strong>Pagamento:</strong> {payment}
          </p>
        </OrderBlock>
      </InfoGrid>
    </Container>
  )
}

export default OrderHeader
